import { createTabPageDescriptor } from "@/lib/tabs/pageDescriptorUtils";

export const SHARED_TAB_PAGES = {
  SettingsPage: createTabPageDescriptor(
    "SettingsPage",
    () => import("@/components/pages/user/SettingsPage/SettingsPage"),
  ),
  LandingPage: createTabPageDescriptor(
    "LandingPage",
    () => import("@/components/pages/shared/LandingPage/LandingPage"),
  ),
};
